import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttributionFromUrl } from "@/lib/utmParams";

/**
 * Fires a GA4 `page_view` event on every SPA route change.
 * The initial pageview is sent by the gtag('config') call in index.html.
 */
export function useGAPageviews() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Persist UTM + click-id attribution from the current URL into sessionStorage
    // so downstream forms can attach it to leads even after navigation.
    captureAttributionFromUrl();

    // Skip the very first render — gtag('config') already fired the initial pageview.
    if (typeof window === "undefined" || !window.gtag) return;

    const page_path = pathname + search;
    const page_location = window.location.href;
    const page_title = document.title;

    window.gtag("event", "page_view", {
      page_path,
      page_location,
      page_title,
    });
  }, [pathname, search]);
}